const mediaItems = [
  {
    title: '暗夜追踪：幕后制作特辑',
    desc: '导演与主演畅谈深夜拍摄的幕后故事，揭秘城市夜景中那些震撼追逐场面的拍摄手法。',
    duration: '18:42',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20at%20night%20with%20camera%20crew%20and%20lighting%20equipment%20on%20city%20street%2C%20warm%20cinematic%20lighting%2C%20documentary%20style%20photography%2C%20professional%20film%20set%20atmosphere&width=800&height=500&seq=media-card-01&orientation=landscape',
    icon: 'ri-movie-2-line',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    title: '星海迷途：视觉特效解析',
    desc: '从概念设计到最终渲染，带你了解这部科幻巨制中震撼太空场景是如何一步步打造出来的。',
    duration: '22:15',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20digital%20workspace%20with%20multiple%20screens%20showing%203D%20spacecraft%20models%20and%20visual%20effects%2C%20warm%20ambient%20monitor%20glow%2C%20creative%20studio%20atmosphere%2C%20cinematic%20color%20grading%20workspace&width=800&height=500&seq=media-card-02&orientation=landscape',
    icon: 'ri-computer-line',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    title: '午夜食堂：主创访谈',
    desc: '编剧团队分享深夜美食剧的创作灵感来源，以及那些让你看得流口水的菜品是如何选定的。',
    duration: '15:30',
    img: 'https://readdy.ai/api/search-image?query=Warm%20interview%20setup%20with%20comfortable%20seating%20and%20soft%20lighting%20in%20restaurant%20setting%2C%20food%20magazine%20photography%20style%2C%20cozy%20atmosphere%20with%20steaming%20dishes%20on%20table%2C%20cinematic%20composition&width=800&height=500&seq=media-card-03&orientation=landscape',
    icon: 'ri-chat-voice-line',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    title: '极限追凶：动作设计全纪录',
    desc: '特技团队首次公开午夜高架追逐戏的动作设计全过程，每一秒都经过精密计算和反复排练。',
    duration: '20:08',
    img: 'https://readdy.ai/api/search-image?query=Action%20film%20stunt%20rehearsal%20on%20sound%20stage%20with%20green%20screen%20and%20safety%20equipment%2C%20professional%20crew%20in%20action%2C%20warm%20studio%20lighting%2C%20behind%20the%20scenes%20cinematic%20documentary%20style&width=800&height=500&seq=media-card-04&orientation=landscape',
    icon: 'ri-run-line',
    tagColor: 'bg-primary-100 text-primary-700',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            精彩预告
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            热门影视幕后花絮与独家预告片抢先看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] w-full relative overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-black/50 backdrop-blur-sm group-hover:bg-primary-500 transition-colors duration-300">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="inline-block px-2 py-1 rounded-md bg-black/50 backdrop-blur-sm text-background-50 text-[10px] font-medium">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold ${item.tagColor}`}>
                    <i className={`${item.icon} text-[9px]`}></i>
                    花絮
                  </span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}